export default {
    expandProfileData: function() {
        if (! this.isMounted) {
            return
        }

        let workProfiles = this.$refs['workProfiles'],
            expand = 0,
            openProfiles = 0

        if (workProfiles) {
            for (let item in workProfiles.openProfiles)  {
                if (workProfiles.openProfiles[item] !== null) {
                    expand = null
                }

                if (typeof workProfiles.openProfiles[item] === 'number') {
                    openProfiles++
                }
            }
        }

        if (typeof expand !== 'number' && openProfiles === 1) {
            for (let item in workProfiles.openProfiles) {
                if (typeof workProfiles.openProfiles[item] === 'number') {
                    window.setTimeout(() => {
                        this.$vuetify.goTo(`#${item}`)
                    }, 400)

                    return
                }
            }
        }

        return expand
    }
}
